import { createSlice } from '@reduxjs/toolkit';
import { userApi } from '@/store/api/userApi';

interface UserProfile {
  id: string;
  username: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  mobile?: string;
  isSelfRegistered?: boolean;
  isAffiliateUser?: boolean;
  role?: { name: string };
  createdBy?: string | null;
  referralCode?: string;
}

interface UserState {
  profile: UserProfile | null;
  isMasterOwnerUser: boolean | null;
}

const initialState: UserState = {
  profile: null,
  isMasterOwnerUser: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUser: (state) => {
      state.profile = null;
      state.isMasterOwnerUser = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(userApi.endpoints.getUserProfile.matchFulfilled, (state, { payload }) => {
      state.profile = payload;
    });
    builder.addMatcher(userApi.endpoints.getIsMasterOwner.matchFulfilled, (state, { payload }) => {
      state.isMasterOwnerUser = payload;
    });
  },
});

export const { clearUser } = userSlice.actions;
export default userSlice.reducer;
